class TableGridAccordionToggleCellController {

  constructor() {
    this.name = 'tableGridAccordionToggleCell';
  }
}

export default TableGridAccordionToggleCellController;



// WEBPACK FOOTER //
// ./app/components/tableGridAccordionToggleCell/tableGridAccordionToggleCell.controller.js